<template>
  <li v-if="to">
    <router-link
      :to="to"
      :class="{ 'is-active': active }"
    >
      <slot>{{ $t(label) }}</slot>
    </router-link>
  </li>
  <li v-else>
    {{ $t(label) }}
  </li>
</template>

<script>
 export default {
   props: {
     to: {
       type: Object,
       default: () => ({})
     },
     label: {
       type: String,
       default: null
     },
     active: {
       type: Boolean,
       default: false
     }
   }
 }
</script>

<style scoped>
 .breadcrumb a:hover {
 text-decoration: underline; 
}
</style>